import { createIcon } from '@chakra-ui/react';

export const Logo = createIcon({
  displayName: 'Logo',
  viewBox: '0 0 50 49',
  defaultProps: {
    fill: 'none',
    height: '49',
    width: '50',
  },
  path: (
    <>
      <path
        d="M6.15609 19.814V4.60736C6.15609 3.85283 6.75585 3.23373 7.49103 3.23373H32.5452C33.2804 3.23373 33.8995 3.85283 33.8995 4.60736V4.76213H36.2211V4.60736C36.2211 2.57594 34.5766 0.912109 32.5452 0.912109H7.49103C5.47896 0.912109 3.83447 2.57594 3.83447 4.60736V19.814C3.83447 21.3811 4.82116 22.7353 6.19479 23.2577V20.1042C6.17544 20.0074 6.15609 19.9107 6.15609 19.814Z"
        fill="#00326B"
        style={{ fill: 'color(display-p3 0.0000 0.1961 0.4196)', fillOpacity: 1 }}
      />
      <path
        d="M49.1053 11.785V33.3374C49.1053 35.3301 47.6349 36.9359 45.8163 36.9359H22.8516C19.1757 33.4728 15.2676 31.4414 11.1854 30.8417C10.6437 30.7643 10.1407 30.7256 9.6377 30.6869V11.785C9.6377 9.79231 11.1081 8.18652 12.9267 8.18652H45.8356C47.6542 8.18652 49.1246 9.79231 49.1246 11.785H49.1053Z"
        fill="#00326B"
        style={{ fill: 'color(display-p3 0.0000 0.1961 0.4196)', fillOpacity: 1 }}
      />
      <path
        d="M15.5777 35.9108C13.9719 35.0596 12.3274 34.5179 10.6636 34.2857C5.49798 33.5312 2.09294 36.085 1.95751 36.1817C1.45449 36.5686 1.35776 37.2845 1.74469 37.8068C1.97686 38.1164 2.34445 38.2712 2.71204 38.2712C3.73742 37.6908 4.95627 37.1297 6.36859 36.6847C8.67086 35.9689 11.747 35.4659 15.5777 35.9302V35.9108Z"
        fill="#57B3FF"
        style={{ fill: 'color(display-p3 0.3412 0.7020 1.0000)', fillOpacity: 1 }}
      />
      <path
        d="M38.2717 48.8736C33.2995 48.8736 28.4048 46.9196 24.7676 44.9849C18.654 41.7346 12.9466 40.7479 8.2647 42.1796C4.76293 43.2437 3.02171 45.2751 3.00236 45.3138C2.59608 45.7974 1.8609 45.8748 1.37723 45.4685C0.893556 45.0623 0.816168 44.3271 1.22245 43.8434C1.29984 43.7467 3.33126 41.309 7.45214 40.0127C14.1461 37.9039 21.169 40.4577 25.8703 42.9535C32.2741 46.3585 38.0588 47.3839 42.6247 45.9329C46.0297 44.8494 47.5968 42.7406 47.6162 42.7213C48.0031 42.1989 48.719 42.0828 49.2413 42.4698C49.7637 42.8374 49.8798 43.5532 49.5122 44.0756C49.4348 44.1917 47.5775 46.7454 43.5147 48.0997C41.7928 48.6801 40.0516 48.9123 38.291 48.9123V48.8736H38.2717Z"
        fill="#0074E0"
        style={{ fill: 'color(display-p3 0.0000 0.4549 0.8784)', fillOpacity: 1 }}
      />
    </>
  ),
});
